import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { QuestionPaperModalAdapter } from './dtos/model-paper.adapter';
import { ChapterWiseModel } from './entities/chapter-wise-model.entity';
import { QuestionPaperModal } from './entities/question-paper-modal';
import { SectionWiseModel } from './entities/section-wise-model.entity';
import { ModelPaperController } from './model-paper.controller';
import { ModelPaperService } from './model-paper.service';
import { ChapterWiseModelRepo } from './repositories/chapter-wise-model.repo';
import { ModelPaperRepo } from './repositories/model-paper-repo';
import { LanguagesRepo } from '../ai-generated-qp/repo/languages-repo';
import { SubjectRepo } from '../ai-generated-qp/repo/subject-repo';
import { ChapterRepo } from '../ai-generated-qp/repo/chapter-repo';
import { AuthenticationEntity } from '../authentications/entities/authentications.entity';

@Module({
  imports: [TypeOrmModule.forFeature([QuestionPaperModal, SectionWiseModel, ChapterWiseModel, AuthenticationEntity])],
  controllers: [ModelPaperController],
  providers: [ModelPaperService, QuestionPaperModalAdapter, ModelPaperRepo, ChapterWiseModelRepo, LanguagesRepo, SubjectRepo, ChapterRepo],
  exports: [ModelPaperService]
})
export class ModelPaperModule { }
